export const defaultControllerAttributes = {
    visible: !0,
    style: {
        x: 0,
        y: 0,
        dx: 0,
        dy: 0,
        size: 20
    },
    order: 0,
    space: 10
};

export const RailDefaultSize = [ 200, 10 ];
//# sourceMappingURL=constant.js.map
